export const Read = 'prs:read_access';
export const Write = 'prs:write_access';
export const Internal = 'prs:internal_access';
export const ProjRead = 'project_service:read_access';
export const ProjWrite = 'project_service:write_access';
export const ProjUiAccess = 'project_service:ui_access';
